import { Suspense, useRef, useState } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Toolbar } from 'primereact/toolbar';
import { useNavigate } from 'react-router-dom';
import { TabView, TabPanel } from 'primereact/tabview';
import { MenuItem } from 'primereact/menuitem';
import SettingsTabRoadmaps from '../components/SiteSettings/SettingsTabRoadmaps';
import SettingsTabTimezone from '../components/SiteSettings/SettingsTabTimezone';
import { Toast } from 'primereact/toast';
import { SitesQuery$data } from '../graphQLOperations/__generated__/SitesQuery.graphql';
import QuerySites from '../components/SiteSettings/QuerySites';
import BarToCircle from '../assets/BarToCircle/BarToCircle';

const Settings = () => {
  const toast = useRef<Toast | null>(null);
  const navigate = useNavigate();
  const [fetchKey, setFetchKey] = useState<number>(0);
  const [refetchingData, setRefetchingData] = useState<boolean>(false);
  const breadcrumbItems: MenuItem[] = [{ label: 'Set Up', command: () => navigate('/setting-up') }, { label: 'Sites' }];
  const [sitesData, setSitesData] = useState<SitesQuery$data | null>(null);
  const home: MenuItem = { icon: 'nc_icon-nc_home icon-sm', command: () => navigate('/') };

  return (
    <>
      <div className="grid nc_content-frame nc_page-inner">
        <Toast ref={toast} />
        <Toolbar className="col-10 col-offset-1 nc_page-header" center={<h1>Sites</h1>} />
        <BreadCrumb className="col-10 col-offset-1 nc_breadcrumb" model={breadcrumbItems} home={home} />

        <div className="col-10 col-offset-1 nc_block">
          {sitesData === null ? (
            <BarToCircle />
          ) : (
            <TabView className="nc_tabView">
              <TabPanel
                header={
                  <div className="flex align-items-center">
                    <span className="nc_icon-nc_map icon-sm mr-1"></span>Roadmaps
                  </div>
                }
                className="flex flex-column"
                disabled={refetchingData}
              >
                <SettingsTabRoadmaps
                  data={sitesData}
                  toast={toast}
                  setFetchKey={setFetchKey}
                  setRefetchingData={setRefetchingData}
                />
              </TabPanel>
              <TabPanel
                header={
                  <div className="flex align-items-center">
                    <span className="nc_icon-nc_levers icon-sm mr-1"></span>Time Zones
                  </div>
                }
                className="flex flex-column"
                disabled={refetchingData}
              >
                <SettingsTabTimezone
                  data={sitesData}
                  toast={toast}
                  setFetchKey={setFetchKey}
                  setRefetchingData={setRefetchingData}
                />
              </TabPanel>
            </TabView>
          )}
          <Suspense>
            <QuerySites setSitesData={setSitesData} fetchKey={fetchKey} setRefetchingData={setRefetchingData} />
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default Settings;
